import { render, staticRenderFns } from "./SubmitIntro.vue?vue&type=template&id=737d0fe5&"
import script from "./SubmitIntro.vue?vue&type=script&lang=js&"
export * from "./SubmitIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports